import { useState } from "react";
import { DollarSign, TrendingUp } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const BuyerSavingsCalculator = () => {
  const [homePrice, setHomePrice] = useState(450000);
  const [savings, setSavings] = useState(27000);

  const calculateSavings = (price) => {
    // Typical 6% commission, buyer's agent gets 3%
    // Buying FSBO saves the 2.5-3% typically passed to buyer
    const avgSavings = price * 0.06; // Full 6% savings potential
    setSavings(Math.round(avgSavings));
  };

  const handlePriceChange = (e) => {
    const price = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
    setHomePrice(price);
    calculateSavings(price);
  };

  return (
    <Card className="bg-gradient-to-br from-blue-50 to-green-50 border-2 border-blue-300 p-8">
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-600 rounded-full mb-4">
          <DollarSign className="w-8 h-8 text-white" />
        </div>
        <h3 className="text-3xl font-bold text-gray-900 mb-2">
          💰 Your FSBO Savings Calculator
        </h3>
        <p className="text-gray-700">
          See how much you could save buying directly from homeowners
        </p>
      </div>

      <div className="max-w-md mx-auto space-y-6">
        <div>
          <label className="block text-sm font-bold text-gray-700 mb-2">
            Home Purchase Price:
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-xl font-bold">
              $
            </span>
            <Input
              type="text"
              value={homePrice.toLocaleString()}
              onChange={handlePriceChange}
              className="pl-8 text-2xl font-bold text-center border-2 border-blue-400"
              placeholder="450,000"
            />
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 border-4 border-green-500 shadow-xl">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <TrendingUp className="w-6 h-6 text-green-600" />
              <span className="text-lg font-semibold text-gray-700">
                Your Estimated Savings:
              </span>
            </div>
            <div className="text-5xl font-extrabold text-green-600 mb-2">
              ${savings.toLocaleString()}
            </div>
            <p className="text-sm text-gray-600">
              Average 6% commission saved buying FSBO
            </p>
          </div>
        </div>

        <div className="bg-blue-600 text-white rounded-lg p-4 text-center overflow-hidden">
          <p className="text-sm mb-3 break-words">
            <strong>Plus:</strong> Many sellers offer to pay your closing costs when you buy direct!
          </p>
          <Button
            className="w-full bg-white text-blue-600 hover:bg-gray-100 font-bold text-base sm:text-lg py-4 sm:py-6 whitespace-normal leading-tight"
            onClick={() => window.location.href = '/search'}
          >
            Find Homes Where Sellers Pay YOUR Closing Costs →
          </Button>
        </div>

        <p className="text-xs text-gray-600 text-center">
          * Savings based on typical 6% real estate commission. Actual savings may vary. 
          DFW average home price: $450K = $27K in potential savings.
        </p>
      </div>
    </Card>
  );
};

export default BuyerSavingsCalculator;
